import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "devicetype-packetparser"
  }, [_c(VExpansionPanels, {
    staticClass: "my-4 dt-card-text-01",
    attrs: {
      "value": undefined
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_c('div', {
    staticClass: "text-bold"
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.quickReferenceHeader')) + "\n        ")])]), _c(VExpansionPanelContent, [!_vm.parserConfigInternal.custom ? _c('div', {
    class: _vm.modeClass,
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.parserHelpText'))
    }
  }) : _vm._e(), _c('div', {
    class: _vm.modeClass,
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.calcluateHelpText'))
    }
  }), _c('div', {
    class: _vm.modeClass,
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.variablesHelpText'))
    }
  }), _c('div', [_c('custom-code', {
    attrs: {
      "block": ""
    }
  }, [_vm._v("{ \"gps\": { \"latitude\": null, \"longitude\": null } }")]), _c('custom-code', [_vm._v("array[0], array[1]")]), _c('custom-code', {
    attrs: {
      "block": ""
    }
  }, [_vm._v("{ \"array\": [ null, null ] }")])], 1)])], 1)], 1), _vm.hidePredefinedParserSelection === false && !_vm.switchParserMode ? _c(VExpansionPanels, {
    staticClass: "my-4 dt-card-text-01 parser-elements",
    attrs: {
      "value": 0
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_c('div', {
    staticClass: "text-bold",
    attrs: {
      "data-cy": "parser_text_bold"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.predefinedHeader')) + "\n        ")])]), _c(VExpansionPanelContent, [_c(VSelect, {
    staticClass: "my-2",
    attrs: {
      "data-cy": "predefined_parser",
      "items": _vm.predefinedParserVars,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": _vm.formSaving || _vm.readonly,
      "label": _vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.predefinedHeader'),
      "item-text": "name",
      "item-value": "id",
      "hide-details": "auto",
      "return-object": ""
    },
    on: {
      "change": function ($event) {
        return _vm.predefinedParserSelected();
      }
    },
    model: {
      value: _vm.predefinedParser,
      callback: function ($$v) {
        _vm.predefinedParser = $$v;
      },
      expression: "predefinedParser"
    }
  })], 1)], 1)], 1) : _vm._e(), !_vm.parserConfigInternal.custom ? _c(VExpansionPanels, {
    staticClass: "my-4 dt-card-text-01 parser-elements",
    attrs: {
      "value": 0
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_c('div', {
    staticClass: "text-bold",
    attrs: {
      "data-cy": "parser_header"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.parserHeader')) + "\n        ")])]), _c(VExpansionPanelContent, [!_vm.readonly && (!_vm.parserConfigInternal.parseElements || !_vm.parserConfigInternal.parseElements.length) ? _c(VRow, {
    attrs: {
      "align": "center"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12",
      "align": "right"
    }
  }, [_c('core-button', {
    attrs: {
      "color": _vm.color,
      "disabled": _vm.readonly,
      "prepend-icon": "fa-plus"
    },
    on: {
      "click": function ($event) {
        return _vm.addParseBitRange(0);
      }
    }
  })], 1)], 1) : _vm._e(), _vm._l(_vm.parserConfigInternal.parseElements, function (pElement, i) {
    return _c(VRow, {
      key: `p-element-${i}`
    }, [_c(VCol, {
      staticClass: "ma-0 pa-0",
      attrs: {
        "cols": "12",
        "md": "7"
      }
    }, [_c(VRow, {
      staticClass: "ma-0 pa-0"
    }, [_c(VCol, {
      attrs: {
        "cols": "3",
        "sm": "2",
        "lg": "1"
      }
    }, [_c('p', {
      staticClass: "card-description mt-2 mb-0 py-0",
      staticStyle: {
        "min-width": "36px"
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.bitRange(i)) + "\n                ")])]), _c(VCol, {
      attrs: {
        "cols": "9",
        "sm": "4",
        "lg": "3"
      }
    }, [_c(VTextField, {
      staticClass: "required",
      attrs: {
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "rules": pElement.type === 'float' ? _vm.parseBitsFloatRule : _vm.requiredRule,
        "disabled": _vm.formSaving || _vm.readonly,
        "label": _vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.bitRange'),
        "type": "number",
        "hide-details": "auto",
        "autocomplete": "off",
        "required": "",
        "dense": ""
      },
      model: {
        value: pElement.bits,
        callback: function ($$v) {
          _vm.$set(pElement, "bits", $$v);
        },
        expression: "pElement.bits"
      }
    })], 1), _c(VCol, {
      attrs: {
        "cols": "12",
        "sm": "6",
        "lg": "8"
      }
    }, [_c(VSelect, {
      staticClass: "required",
      attrs: {
        "items": [{
          text: 'Integer',
          value: 'int'
        }, {
          text: 'Boolean',
          value: 'boolean'
        }, {
          text: 'String',
          value: 'string'
        }, {
          text: 'Float',
          value: 'float'
        }, {
          text: 'Hex',
          value: 'hex'
        }],
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "rules": _vm.requiredRule,
        "disabled": _vm.formSaving || _vm.readonly,
        "label": _vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.type'),
        "hide-details": "auto",
        "dense": ""
      },
      model: {
        value: pElement.type,
        callback: function ($$v) {
          _vm.$set(pElement, "type", $$v);
        },
        expression: "pElement.type"
      }
    })], 1)], 1), _c(VRow, {
      staticClass: "ma-0 pa-0"
    }, [_c(VCol, {
      staticClass: "ma-0 pa-0",
      attrs: {
        "cols": "0",
        "lg": "4"
      }
    }), pElement.type === 'int' || pElement.type === 'float' ? _c(VCol, {
      staticClass: "mt-0 pt-0 pr-1",
      attrs: {
        "cols": "3",
        "lg": "2"
      }
    }, [_c(VCheckbox, {
      staticClass: "mt-1",
      attrs: {
        "color": _vm.color,
        "disabled": _vm.formSaving || _vm.readonly,
        "label": "Little",
        "hide-details": "",
        "dense": ""
      },
      model: {
        value: pElement.littleEndian,
        callback: function ($$v) {
          _vm.$set(pElement, "littleEndian", $$v);
        },
        expression: "pElement.littleEndian"
      }
    })], 1) : _vm._e(), pElement.type === 'int' ? _c(VCol, {
      staticClass: "mt-0 pt-0 px-1",
      attrs: {
        "cols": "3",
        "lg": "2"
      }
    }, [_c(VCheckbox, {
      staticClass: "mt-1",
      attrs: {
        "color": _vm.color,
        "disabled": _vm.formSaving || _vm.readonly,
        "label": "Signed",
        "hide-details": "",
        "dense": ""
      },
      model: {
        value: pElement.signed,
        callback: function ($$v) {
          _vm.$set(pElement, "signed", $$v);
        },
        expression: "pElement.signed"
      }
    })], 1) : _vm._e(), pElement.type === 'int' && pElement.signed ? _c(VCol, {
      staticClass: "mt-0 pt-0 pl-1",
      attrs: {
        "cols": "6",
        "lg": "4"
      }
    }, [_c(VSelect, {
      attrs: {
        "items": [{
          text: 'One\'s complement',
          value: '1'
        }, {
          text: 'Two\'s complement',
          value: '2'
        }],
        "color": _vm.color,
        "filled": _vm.inpFilled,
        "rules": _vm.requiredRule,
        "disabled": _vm.formSaving || _vm.readonly,
        "label": "",
        "hide-details": "auto",
        "dense": ""
      },
      model: {
        value: pElement.signComplement,
        callback: function ($$v) {
          _vm.$set(pElement, "signComplement", $$v);
        },
        expression: "pElement.signComplement"
      }
    })], 1) : _vm._e()], 1)], 1), _c(VCol, {
      attrs: {
        "cols": "12",
        "md": "5"
      }
    }, [_c(VTextField, {
      staticClass: "required",
      attrs: {
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "rules": _vm.parserTargetIsUniqueRule,
        "disabled": _vm.formSaving || _vm.readonly,
        "label": _vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.targetVariable'),
        "hide-details": "auto",
        "autocomplete": "off",
        "required": "",
        "dense": ""
      },
      scopedSlots: _vm._u([{
        key: "append-outer",
        fn: function () {
          return [!_vm.readonly ? _c('core-button', {
            attrs: {
              "color": _vm.color,
              "disabled": _vm.readonly,
              "prepend-icon": "fa-plus"
            },
            on: {
              "click": function ($event) {
                return _vm.addParseBitRange(i);
              }
            }
          }) : _vm._e(), !_vm.readonly ? _c('core-button', {
            attrs: {
              "color": _vm.color,
              "disabled": _vm.readonly,
              "prepend-icon": "fa-trash-alt"
            },
            on: {
              "click": function ($event) {
                return _vm.removeParseBitRange(i);
              }
            }
          }) : _vm._e()];
        },
        proxy: true
      }], null, true),
      model: {
        value: pElement.target,
        callback: function ($$v) {
          _vm.$set(pElement, "target", $$v);
        },
        expression: "pElement.target"
      }
    })], 1), _c(VDivider)], 1);
  })], 2)], 1)], 1) : _vm._e(), _c('niota-classic-devicetypes-packet-parser-calculation', {
    attrs: {
      "switchParserMode": _vm.switchParserMode,
      "calculate-elements": _vm.parserConfigInternal.calculateElements,
      "readonly": _vm.readonly
    },
    on: {
      "config-updated": _vm.onCalculationConfigUpdated
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };